<script lang="ts" setup>
import { inject, nextTick, ref } from "vue"
import { v4 as uuidv4 } from "uuid"
import { defaultsDeep } from "lodash-es"

interface ComponentProps {
  option?: {
    symbol: string
    effectColor?: string
    color?: string
    scale?: number
    size?: number
  }
  effectOpt?: {
    period: number //动画的周期，秒数。
    brushType: number //波纹的绘制方式，可选 'stroke' 和 'fill'。
    scale: number //动画中波纹的最大缩放比例。
    color: string //涟漪的颜色，默认为散点的颜色。
    number: number //波纹的数量。
  }
  data: { name: string; value: number[] }[]
}

const props = withDefaults(defineProps<ComponentProps>(), {
  option: () => ({
    symbol: "circle",
    effectColor: "#7ce7fd",
    color: "#5cc8d4",
    scale: 60,
    size: 2,
  }),
  data: () => [],
})

const coordinateSystem = inject("coordinateSystem") as string
const updateSeries = inject("updateSeries") as any

const effect = ref<any>({})

if (!props.effectOpt) {
  switch (props.option.symbol) {
    case "circle": {
      effect.value = {
        period: 3,
        brushType: "fill",
        scale: props.option.scale || 60,
        color: props.option.effectColor || "#7ce7fd",
        number: 2,
      }
      break
    }
  }
} else {
  if (props.effectOpt) {
    effect.value = defaultsDeep(props.effectOpt, effect.value)
  }
}

const linesConfig = ref({
  id: uuidv4(),
  type: "effectScatter",
  coordinateSystem,
  zlevel: 2,
  rippleEffect: effect.value,
  symbol: "circle", // 图标样式
  symbolSize: props.option.size || 2,
  itemStyle: {
    color: props.option.color || "#5cc8d4",
  },
  // 中心点数据
  data: [] as any[],
})

const setData = (opt: { data: { name: string; value: number[] }[] }) => {
  linesConfig.value.data = opt.data
  updateSeries(linesConfig.value)
}

nextTick(() => {
  setData({ data: props.data })
})

defineExpose({
  setData,
})
</script>
